import { RootState } from 'store/store';
import { useSelector } from 'react-redux';
import { useSidebar } from '../ui/sidebar';
import { useIsMobile } from 'hooks/use-mobile';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default () => {
  const navigate = useNavigate();

  const { user } = useSelector((state: RootState) => state.common);

  const { open, setOpenMobile, openMobile } = useSidebar();

  const isMobileScreen = useIsMobile();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) navigate('/login');
    setLoading(false);
  }, [user]);

  return { open, setOpenMobile, openMobile, isMobileScreen, loading };
};
